module.exports = __webpack_public_path__ + "static/media/tooth.2477f67b.svg";